export const editMutations = <const>{
	SLEVAMAT_RABAT_SK_SELECT_MAPPER: 'SLEVAMAT_RABAT_SK_SELECT_MAPPER',
};

export const listMutations = <const>{
	SLEVAMAT_RABAT_SK_FILTER_SELECT_MAPPER: 'SLEVAMAT_RABAT_SK_FILTER_SELECT_MAPPER',
};
